import { useEffect, useRef } from 'react';
import { ROLL_DISPLAY_MS } from '../../../utils/rollDisplay';

/**
 * Calls `onDismiss` once `delay` ms after `showKey` last changed, while `enabled`. A new key (a new roll) restarts the
 * wait; a falsy key or `enabled: false` (for example, saves still pending) cancels it.
 */
export default function useAutoDismiss({ showKey, onDismiss, enabled = true, delay = ROLL_DISPLAY_MS }) {
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;
  useEffect(() => {
    if (!showKey || !enabled) return undefined;
    const timer = setTimeout(() => dismiss.current?.(), delay);
    return () => clearTimeout(timer);
  }, [showKey, enabled, delay]);
}
